// extracted by mini-css-extract-plugin
export default {"wrap":"k-z","heading":"l-z","formError":"m-z"};